import { Component, EventEmitter, Input, Output, SimpleChanges } from '@angular/core';
import { ProjectService } from '../../../services/project.service';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { StorageService } from '../../../../Common/services/storage.service';
import { UserRoleServiceService } from '../../../../shared/services/user-role-service.service';
import { MessageService } from '../../../services/message.service';
import { ErrorLoggerService } from '../../../../shared/services/error-logger.service';
import { FundingAndRMS } from '../../../models/project-vm';
import { UserLogin } from '../../../../Common/models/user.login';
import { FileUploadModel } from '../../../../shared/flexible-file-upload/flexible-file-upload.component';
import { ProjectConstants } from '../../../constants/component-messages';
import { RolesKeysConstants } from '../../../../Common/Constants/data';
import { UnsavedChangesService } from '../../../../unsaved-changes.service';

@Component({
  selector: 'app-funding-rms',
  templateUrl: './funding-rms.component.html',
  styleUrl: './funding-rms.component.css'
})
export class FundingRmsComponent {
  
  fundingTypes: any = [
    {id:1, name:'JTBD', disabled: false},
    {id:2, name:'CMF', disabled: false},
    // {id:3, name:'Initiaitve Fund', disabled: false},
    {id:4, name:'Category or Initiative Fund', disabled: false}
  ];
  
  @Input() selectedFundingRMS: FundingAndRMS | null | undefined;
  @Input() disableFields: boolean = false;
  @Input() estimatedTotalCost: number = 0;
  @Output() notifyFundingRMSObject = new EventEmitter<FundingAndRMS>();
  
  userDisplayName: string | null = "";
  selectedFundingType: number = 0;
  uInfo: UserLogin | null | undefined;
  selectedFiles: FileUploadModel | null = null;
  selSREFileUpload: FileUploadModel | null = null;
  disableFileUpload: boolean = false;
  cmfDisbaledControls: boolean = false;
  categoryDisbaledControls: boolean = false;
  sreReviewDisbaledControls: boolean = false;
  sreReviewCheckboxDisbaledControls: boolean = false;
  sreUsers: any = [];
  

  sreDropdownEnabled = false;
  sreFileUploadEnabled = false;
  cmfPromoEnabled = false;
  cmfTacticEnabled = false;
  estimatedCostEnabled = false;
  approvalEmailEnabled = false;
  isSreCheckboxEnabled = false;
  isInitializing = false;

  fundRMSCategoryFileName = 'CategoryFile';
  fundRMSJTBDFileName = 'JTBDFile';


  constructor(private projectService:ProjectService,
    private msgService: MessageService,
    private ngxService: NgxUiLoaderService,
    private storageService: StorageService,
    private userRoleService: UserRoleServiceService,
    private errorLogService: ErrorLoggerService,
    private unsavedChangesService: UnsavedChangesService
  ) {}

  onAnyFieldValueChange(e:boolean){
    if(e){
      this.unsavedChangesService.setUnsavedChanges(true);
    }
  }

  async ngOnInit()
  {
    this.uInfo = this.storageService.getItem<UserLogin>("UserInfo");
    this.resetControls();
    // this.selectedFundingRMS = new FundingAndRMS();
    // this.selectedFundingRMS.fundingType = 0;
    // this.selectedFundingRMS.reviewedBy = 0;//this.uInfo?.userID;
    // this.selectedFundingRMS.createdBy = this.uInfo?.userID;
        
    // this.sreReviewCheckboxDisbaledControls = true;
    // this.sreReviewDisbaledControls = true;
    // this.categoryDisbaledControls = true;
    // this.cmfDisbaledControls = true;

    // this.selectedFiles = {
    //   fileName:'',
    //   base64Bytes: '',
    //   rowsTotalCount: 0,
    //   fileChanged: false
    // };

    // this.selSREFileUpload = {
    //   fileName:'',
    //   base64Bytes: '',
    //   rowsTotalCount: 0,
    //   fileChanged: false
    // };
    
    // if(this.selectedFundingRMS != null)
    // {
    //   this.selectedFundingRMS.createdBy = this.uInfo?.userID;
    // }

    let vendorDetails = this.storageService.getItem<any>("selectedVendor");
    if(vendorDetails.vendorID > 0)
    {
      this.projectService.getSREUsers(vendorDetails.vendorID).subscribe({
        next:data => {
          this.sreUsers = [];
          this.sreUsers = data;
        },
        error: error => {
          //this.msgService.htmlError('Error occured');
          this.errorLogService.logError(error, 'FundingRmsComponent > ngOnInit');
          this.ngxService.stop();
        }
      }
      );
    }
    if (this.userRoleService.role?.roleKey == RolesKeysConstants.RoleKey_SREAdmin || 
      (this.userRoleService.role?.roleKey== RolesKeysConstants.RoleKey_SRESupport 
        && this.userRoleService.role?.write == true)){
           this.estimatedCostEnabled=true;
        } else {
          this.estimatedCostEnabled=false;
        }

    // this.notifyFundingRMSObject.emit(this.selectedFundingRMS!);
  }


  resetControls() {        
    if(this.selectedFundingRMS == null)
    {
      this.selectedFundingRMS = new FundingAndRMS();
    }

    this.selectedFundingRMS.createdBy = this.uInfo?.userID;
    this.isSreCheckboxEnabled = false;
    this.sreDropdownEnabled = false;
    this.sreFileUploadEnabled = false;
    this.cmfPromoEnabled = false;
    this.cmfTacticEnabled = false;
    this.estimatedCostEnabled = false;
    this.approvalEmailEnabled = false;
    if (this.userRoleService.role?.roleKey == RolesKeysConstants.RoleKey_SREAdmin || 
      (this.userRoleService.role?.roleKey== RolesKeysConstants.RoleKey_SRESupport 
        && this.userRoleService.role?.write == true)){
           this.estimatedCostEnabled=true;
        } else {
          this.estimatedCostEnabled=false;
        }
  }

  resetModelData() {   
    this.selectedFundingRMS!.sreReviewed = false;
    this.selectedFundingRMS!.reviewedBy = 0;
    this.selectedFundingRMS!.cmfPromo = null;
    this.selectedFundingRMS!.cmfTactIcID = null;
    //this.selectedFundingRMS!.estimatedCost = null;
    this.selectedFiles = this.resetFile();
    this.selSREFileUpload = this.resetFile();
  }

  onFundingTypeChange() {
    this.resetControls();

    if(!this.isInitializing)
    {
      this.resetModelData();
    }

    let ft: number = 0;
    if(this.selectedFundingRMS!.fundingType! != null
      && this.selectedFundingRMS!.fundingType! != undefined
      && this.selectedFundingRMS!.fundingType! > 0
    )
    {
      ft = Number(this.selectedFundingRMS!.fundingType);
    }

    switch (ft) {
      case 1:
        
        // SRE REVIEWED true only for SRE Admin & SRE Support With Write Access
        if (this.userRoleService.role ?.roleKey == RolesKeysConstants.RoleKey_SREAdmin ||
          (this.userRoleService.role ?.roleKey == RolesKeysConstants.RoleKey_SRESupport
            && this.userRoleService.role ?.write == true)) {
          this.isSreCheckboxEnabled = true;
        } else {
          this.isSreCheckboxEnabled = false;
        }       
        
        this.sreDropdownEnabled = true;
        this.sreFileUploadEnabled = true;
        //this.onSreReviewChange();
        // if(this.selectedFundingRMS!.sreReviewed)
        // {
        //   this.onSreReviewChange();
        // }

        // if(!this.isInitializing)
        // {
        //   //this.selectedFundingRMS!.sreReviewed = false;        
        //   this.selectedFundingRMS!.reviewedBy = 0;
        //   this.selectedFundingRMS!.cmfPromo = null;
        //   this.selectedFundingRMS!.cmfTactIcID = null;
        //   this.selectedFundingRMS!.estimatedCost = null;
        //   this.selectedFiles = this.resetFile();
        //   this.selSREFileUpload = this.resetFile();
        // }

        //this.onSreReviewChange();
        break;
      case 2:
        this.cmfPromoEnabled = true;
        this.cmfTacticEnabled = true;

        // this.selectedFundingRMS!.sreReviewed = false;   
        // this.selectedFundingRMS!.reviewedBy = 0;
        // this.selectedFundingRMS!.estimatedCost = null;
        // this.selectedFiles = this.resetFile();
        // this.selSREFileUpload = this.resetFile();
        break;
      case 4:
       // this.estimatedCostEnabled = true;
        this.approvalEmailEnabled = true;

        // this.selectedFundingRMS!.sreReviewed = false;  
        // this.selectedFundingRMS!.reviewedBy = 0;
        // this.selectedFundingRMS!.cmfPromo = null;
        // this.selectedFundingRMS!.cmfTactIcID = null;
        // this.selSREFileUpload = this.resetFile();
        break;
      case 3:
        // All controls are already disabled by resetControls()

        // this.selectedFundingRMS!.sreReviewed = false;  
        // this.selectedFundingRMS!.reviewedBy = 0;
        // this.selectedFundingRMS!.estimatedCost = null;
        // this.selectedFundingRMS!.cmfPromo = null;
        // this.selectedFundingRMS!.cmfTactIcID = null;
        // this.selSREFileUpload = this.resetFile();
        // this.selectedFiles = this.resetFile();
        break;
    }

    this.isInitializing = false;

    this.notifyFundingRMSObject.emit(this.selectedFundingRMS!);
  }

  onSreReviewChange() {
    if (this.selectedFundingRMS!.sreReviewed!) {
      this.sreDropdownEnabled = true;
      this.sreFileUploadEnabled = true;
    } else {
      this.sreDropdownEnabled = false;
      this.sreFileUploadEnabled = false;
    }
  }

  resetFile()
  {
     let fileInit = {
      fileName:'',
      base64Bytes: '',
      rowsTotalCount: 0,
      fileChanged: false
    };
    
    return fileInit;
  }

  async ngOnChanges(changes: SimpleChanges) {
    
    if (changes['selectedFundingRMS'] && this.selectedFundingRMS! != null) {
      this.isInitializing = true;
      this.onFundingTypeChange();
    //   //this.selectedFundingRMS.reviewedBy = 0;//this.uInfo?.userID;
    //   this.userDisplayName = this.selectedFundingRMS.reviewedByName!;

      let fName = '';

      if(this.selectedFundingRMS.fundingType == 1)
      {
        fName = this.selectedFundingRMS!.emailJTBDFileName!;

        if(this.selectedFundingRMS!.base64Bytes != null
          && this.selectedFundingRMS!.base64Bytes != undefined
          && this.selectedFundingRMS!.base64Bytes.length > 0
        )
        {
          this.selSREFileUpload = {
            fileName:  this.selectedFundingRMS!.filename!,
            base64Bytes: this.selectedFundingRMS!.base64Bytes!,
            rowsTotalCount: 0,
            fileChanged: false
          };
        }
      }
      else if(this.selectedFundingRMS.fundingType == 4)
      {
        fName = this.selectedFundingRMS!.emailCategoryFileName!;

        if(this.selectedFundingRMS!.base64Bytes != null
          && this.selectedFundingRMS!.base64Bytes != undefined
          && this.selectedFundingRMS!.base64Bytes.length > 0
        )
        {
          this.selectedFiles = {
            fileName:  this.selectedFundingRMS!.filename!,
            base64Bytes: this.selectedFundingRMS!.base64Bytes!,
            rowsTotalCount: 0,
            fileChanged: false,
            inputFIleID: this.fundRMSCategoryFileName
          };
        }
      }
      else
      {
        fName = '';
      }
      if (this.userRoleService.role?.roleKey == RolesKeysConstants.RoleKey_SREAdmin || 
        (this.userRoleService.role?.roleKey== RolesKeysConstants.RoleKey_SRESupport 
          && this.userRoleService.role?.write == true)){
             this.estimatedCostEnabled=true;
          } else {
            this.estimatedCostEnabled=false;
          }

      

    //   // this.selectedFundingRMS.createdBy = this.uInfo?.userID;

    //   this.fundingTypeDropdownValueChange(true);    
    //   this.checkBoxChangedValue();   
    //   this.selectedFundingRMS.createdBy = this.uInfo?.userID;
    //   this.errorLogService.logMessage(this.selectedFundingRMS!, 'FundingRmsComponent > ngOnChanges');
    // }
    // else
    // {
    //   this.selectedFundingRMS = new FundingAndRMS();
    //   this.selectedFundingRMS.createdBy = this.uInfo?.userID;
    }

    if (changes['estimatedTotalCost'] && this.estimatedTotalCost !== undefined && this.estimatedTotalCost !== null && this.selectedFundingRMS !== null) {
      this.selectedFundingRMS!.estimatedCost = this.estimatedTotalCost;
    }    
  }
  
  handleCategoryFileUpload(event: any)
  {    
    if(event.inputFIleID == this.fundRMSCategoryFileName)
    {
      if((event.base64Bytes != null
        && event.base64Bytes != undefined
        && event.base64Bytes.length > 0)
        || event.isFileDelted
      )
      {
        if(this.selectedFundingRMS!.fundingType == 1)
        {
          this.selectedFundingRMS!.emailJTBDFileName = event.fileName;
          this.selectedFundingRMS!.emailCategoryFileName = null;
        }
        else if(this.selectedFundingRMS!.fundingType == 4)
        {
          this.selectedFundingRMS!.emailJTBDFileName = null;
          this.selectedFundingRMS!.emailCategoryFileName = event.fileName;
        }
        
        this.selectedFundingRMS!.base64Bytes = event.base64Bytes;
        this.selectedFundingRMS!.filename = event.fileName;
        this.selectedFundingRMS!.fileChanged = event.fileChanged;
        this.notifyFundingRMSObject.emit(this.selectedFundingRMS!);
        this.errorLogService.logMessage(event, 'Funcding & RMS > handleFileUpload');
      }
    }
      // else
      // {
      //   this.selectedFundingRMS!.emailCategoryFileName = null;
      //   this.selectedFundingRMS!.base64Bytes = event.base64Bytes;
      //   this.selectedFundingRMS!.filename = event.fileName;
      //   this.selectedFundingRMS!.fileChanged = event.fileChanged;
      //   this.selectedFiles = this.resetFile();
      // }    
  }

  handleSREFileUpload(event: any)
  {    
    if(event.inputFIleID == this.fundRMSJTBDFileName)
    {
      if((event.base64Bytes != null
        && event.base64Bytes != undefined
        && event.base64Bytes.length > 0)
        || event.isFileDelted
      )
      {
        if(this.selectedFundingRMS!.fundingType == 1)
        {
          this.selectedFundingRMS!.emailJTBDFileName = event.fileName;
          this.selectedFundingRMS!.emailCategoryFileName = null;
        }
        else if(this.selectedFundingRMS!.fundingType == 4)
        {
          this.selectedFundingRMS!.emailJTBDFileName = null;
          this.selectedFundingRMS!.emailCategoryFileName = event.fileName;
        }
        
        this.selectedFundingRMS!.base64Bytes = event.base64Bytes;
        this.selectedFundingRMS!.filename = event.fileName;
        this.selectedFundingRMS!.fileChanged = event.fileChanged;
        this.notifyFundingRMSObject.emit(this.selectedFundingRMS!);
        this.errorLogService.logMessage(event, 'Funcding & RMS > handleFileUpload');
      }    
      // else
      // {
      //   this.selectedFundingRMS!.emailJTBDFileName = null;
      //   this.selectedFundingRMS!.base64Bytes = event.base64Bytes;
      //   this.selectedFundingRMS!.filename = event.fileName;
      //   this.selectedFundingRMS!.fileChanged = event.fileChanged;
      //   this.selSREFileUpload = this.resetFile();
      // }
    }
  }

  onSelectFundingType(event: any)
  {
    this.fundingTypeDropdownValueChange(false);
  }

  fundingTypeDropdownValueChange(isLoading: boolean)
  {
    if(this.selectedFundingRMS!.fundingType == 1)
      {
        if(!isLoading)
        {
          //this.selectedFundingRMS!.estimatedCost! = '';
          this.selectedFundingRMS!.estimatedCost! = 0;
          this.selectedFundingRMS!.emailJTBDFileName = null
          this.selectedFundingRMS!.emailCategoryFileName = null;
          this.selectedFundingRMS!.filename = '';
          this.selectedFundingRMS!.fileChanged = false;
          this.selectedFundingRMS!.base64Bytes = null;
          this.disableFileUpload = false;
  
          this.selSREFileUpload = {
            fileName:'',
            base64Bytes: '',
            rowsTotalCount: 0,
            fileChanged: false
          };
    
          this.selectedFiles = {
            fileName:'',
            base64Bytes: null,
            rowsTotalCount: 0,
            fileChanged: false
          };
        }
        else
        {
          // this.selectedFundingRMS!.estimatedCost! = '';
          this.selectedFundingRMS!.estimatedCost! = 0;
          this.selectedFundingRMS!.cmfTactIcID! = '';
          this.selectedFundingRMS!.cmfPromo! = '';

          this.selSREFileUpload = {
            fileName: this.selectedFundingRMS!.filename!,
            base64Bytes: this.selectedFundingRMS!.base64Bytes,
            rowsTotalCount: 0,
            fileChanged: false
          };
        }
  
        this.sreReviewCheckboxDisbaledControls = false;
        this.sreReviewDisbaledControls = true;
        this.categoryDisbaledControls = true;
        this.cmfDisbaledControls = true;
      }
      else if(this.selectedFundingRMS!.fundingType == 4)
      {
        if(!isLoading)
        {
          this.selectedFundingRMS!.emailJTBDFileName = null;
          this.selectedFundingRMS!.emailCategoryFileName = null;
          this.selectedFundingRMS!.filename = '';
          this.selectedFundingRMS!.fileChanged = false;
          this.selectedFundingRMS!.base64Bytes = null;
          this.disableFileUpload = false;
          this.selectedFundingRMS!.sreReviewed! = false;

          this.selectedFundingRMS!.cmfTactIcID! = '';
          this.selectedFundingRMS!.cmfPromo! = '';

          this.selectedFiles = {
            fileName:'',
            base64Bytes: null,
            rowsTotalCount: 0,
            fileChanged: false
          };
    
          this.selSREFileUpload = {
            fileName:'',
            base64Bytes: '',
            rowsTotalCount: 0,
            fileChanged: false
          };
        }
        else{

          this.selectedFundingRMS!.cmfTactIcID! = '';
          this.selectedFundingRMS!.cmfPromo! = '';

          this.selectedFiles = {
            fileName: this.selectedFundingRMS!.filename!,
            base64Bytes: this.selectedFundingRMS!.base64Bytes,
            rowsTotalCount: 0,
            fileChanged: false
          };
        }

        this.sreReviewCheckboxDisbaledControls = true;
        this.sreReviewDisbaledControls = true;
        this.categoryDisbaledControls = false;
        this.cmfDisbaledControls = true;
        //this.fundingTypes[0].disabled = true;      
        this.selectedFundingRMS!.reviewedBy = 0;  
      }
      else
      {
        if(this.selectedFundingRMS!.fundingType == 2)
        {
          this.cmfDisbaledControls = false;
        }
        else
        {
          this.cmfDisbaledControls = true;
        }
        
        if(!isLoading)
        {
          // this.selectedFundingRMS!.estimatedCost! = '';
          this.selectedFundingRMS!.estimatedCost! = 0;
          this.selectedFundingRMS!.cmfTactIcID! = '';
          this.selectedFundingRMS!.cmfPromo! = '';
          this.selectedFundingRMS!.sreReviewed! = false;
        }
        else{

        }
        
        this.sreReviewCheckboxDisbaledControls = true;
        this.sreReviewDisbaledControls = true;
        this.categoryDisbaledControls = true;
        //this.fundingTypes[0].disabled = true;      
        this.selectedFundingRMS!.reviewedBy = 0;
  
        if(!isLoading)
        {
          this.selectedFiles = {
            fileName:'',
            base64Bytes: null,
            rowsTotalCount: 0,
            fileChanged: false
          };
    
          this.selSREFileUpload = {
            fileName:'',
            base64Bytes: '',
            rowsTotalCount: 0,
            fileChanged: false
          };
        }
        this.disableFileUpload = true;
      }
  
      this.notifyFundingRMSObject.emit(this.selectedFundingRMS!);
  }

  onCheckboxChange(event: any) {
    this.selectedFundingRMS!.sreReviewed! = event.target.checked;
    this.checkBoxChangedValue();    
  }

  checkBoxChangedValue()
  {
    if(this.selectedFundingRMS!.sreReviewed!)
      {
        //this.fundingTypes[0].disabled = false;      
        //this.selectedFundingRMS!.reviewedBy = this.uInfo?.userID;   
        this.userDisplayName = this.storageService.getItem<string>("UserDisplayName");
        
        this.sreReviewDisbaledControls = false;
        this.categoryDisbaledControls = true;
        this.cmfDisbaledControls = true;
  
        this.selectedFundingRMS!.fundingType = 1;
        this.selectedFundingRMS!.estimatedCost =null;
    
        this.selectedFundingRMS!.cmfTactIcID! = '';
        this.selectedFundingRMS!.cmfPromo! = '';
        
        this.selectedFiles = {
          fileName:'',
          base64Bytes: null,
          rowsTotalCount: 0,
          fileChanged: false
        };
      }
      else
      {
        //this.fundingTypes[0].disabled = true;
        //this.selectedFundingRMS!.fundingType = 0; 
        this.selectedFundingRMS!.reviewedBy = 0;     
        this.userDisplayName = '';
        this.sreReviewDisbaledControls = true;
  
        this.selSREFileUpload = {
          fileName:'',
          base64Bytes: '',
          rowsTotalCount: 0,
          fileChanged: false
        };
      }
  
      this.notifyFundingRMSObject.emit(this.selectedFundingRMS!);
  }

  onCMFPromoChange()
  {
    this.notifyFundingRMSObject.emit(this.selectedFundingRMS!);
  }

  onCMFTacticIdChange()
  {
    this.notifyFundingRMSObject.emit(this.selectedFundingRMS!);
  }

  onCostChange()
  {
    this.errorLogService.logMessage(this.selectedFundingRMS!, '')
    this.notifyFundingRMSObject.emit(this.selectedFundingRMS!);
  }
  onInputChange_bkp(event: Event) {
    const input = event.target as HTMLInputElement;
    let value = input.value;

    // Remove any non-digit characters
    value = value.replace(/[^0-9]/g, '');

    // Limit the value to 7 digits
    if (value.length > 7) {
      value = value.slice(0, 7);
    }
  }
  onKeyDownEstimatedCost(event: KeyboardEvent) {
    const allowedKeys = ['Backspace', 'Tab', 'ArrowLeft', 'ArrowRight', 'Delete'];
  
    // Allow only digits and control keys
    if (!allowedKeys.includes(event.key) && (event.key < '0' || event.key > '9')) {
      event.preventDefault();
    }
  }

  validateFields(): string[]
  {
    let validationMessages: string[] = []

    if(this.selectedFundingRMS?.fundingType == 2)
    {
      let promo = false;
      let tatic = false;

      if(this.selectedFundingRMS?.cmfPromo == null
        || this.selectedFundingRMS?.cmfPromo == undefined
        || this.selectedFundingRMS?.cmfPromo.length <= 0
      )
      {
        promo = true;
        //validationMessages.push(ProjectConstants.FUNDING_RMS_KEY_CATEGORY_CMF_PROMO_Required);
      }
      
      if(this.selectedFundingRMS?.cmfTactIcID == null
        || this.selectedFundingRMS?.cmfTactIcID == undefined
        || this.selectedFundingRMS?.cmfTactIcID.length <= 0
      )
      {
        tatic = true;
        //validationMessages.push(ProjectConstants.FUNDING_RMS_KEY_CATEGORY_CMF_TACTIC_ID_Required);
      }

      if(promo || tatic)
      {
        validationMessages.push(ProjectConstants.FUNDING_RMS_KEY_CATEGORY_CMF_PROMO_TACTIC_ID_Required);
      }
    }

    if(this.selectedFundingRMS?.fundingType == 4)
    {      
      let estCost = false;
      let apprEmail = false;
      if(this.selectedFundingRMS?.estimatedCost == null
        || this.selectedFundingRMS?.estimatedCost == undefined
        || this.selectedFundingRMS?.estimatedCost < 0
      )
      {
        estCost = true;
        //validationMessages.push(ProjectConstants.FUNDING_RMS_KEY_CATEGORY_COST_Required);
      }      

      if (this.selectedFundingRMS?.base64Bytes == null
        || this.selectedFundingRMS?.base64Bytes == undefined
        || this.selectedFundingRMS?.base64Bytes.length <= 0
      )
      {
        apprEmail = true;
        //validationMessages.push(ProjectConstants.FUNDING_RMS_KEY_CATEGORY_EMAIL_Required);      
      }

      if(apprEmail)
      {
        validationMessages.push(ProjectConstants.FUNDING_RMS_KEY_CATEGORY_EMAIL_Required);
      }
    }

    if(this.selectedFundingRMS?.fundingType == 1)
    {      
      let isSreReviewd = false;
      let isReviewdBy = false;
      let isApproalEmail = false;

      if(this.selectedFundingRMS?.sreReviewed == null
        || this.selectedFundingRMS?.sreReviewed == undefined
        || !this.selectedFundingRMS?.sreReviewed
      )
      {
        isSreReviewd = true;
        //validationMessages.push("SRE ReviewdBy is required.");
      }      

      if(this.selectedFundingRMS?.reviewedBy == null
        || this.selectedFundingRMS?.reviewedBy == undefined
        || this.selectedFundingRMS?.reviewedBy <= 0
      )
      {
        isReviewdBy = true;
        //validationMessages.push("SRE ReviewdBy is required.");
      }      

      // if (this.selectedFundingRMS?.base64Bytes == null
      //   || this.selectedFundingRMS?.base64Bytes == undefined
      //   || this.selectedFundingRMS?.base64Bytes.length <= 0
      // )
      // {
      //   isApproalEmail = true;
      //   //validationMessages.push('Approval email is required.');   
      // }
      //if(isSreReviewd || isReviewdBy || isApproalEmail)

      if(isReviewdBy)
      {
        validationMessages.push(ProjectConstants.FUNDING_RMS_KEY_JTBD_Required);
      }
    }
    return validationMessages;
  }

  onSpocChange(event: any) 
  {
    //this.selectedFundingRMS.sreSpoc = event.target.value;
  }
  // Formats a number as currency string with $, comma separators
formatCurrency(value: number | null | undefined): string {
  if (value === undefined || value === null || isNaN(value)) {
    value = 0;
  }
  return '$' + value.toLocaleString('en-US');
}

// Parses a currency string into a number
parseCurrency(value: string): number {
  // Remove non-numeric characters except for the decimal point
  const numericValue = parseFloat(value.replace(/[^0-9.]+/g, ''));
  return isNaN(numericValue) ? 0 : numericValue;
}

onInputChange(event: Event): void {
  const input = event.target as HTMLInputElement;
  let value = input.value;

  // Remove any non-digit characters, keeping decimal points if necessary
  value = value.replace(/[^0-9.]/g, '');

  // Ensure only one decimal point is allowed
  const parts = value.split('.');
  if (parts.length > 2) {
    value = parts[0] + '.' + parts.slice(1).join('');
  }

  // Limit the value to 7 digits before the decimal point
  if (parts[0].length > 7) {
    value = parts[0].slice(0, 7) + (parts[1] ? '.' + parts[1] : '');
  }

  // Ensure selectedFundingRMS is not null or undefined
  if (this.selectedFundingRMS) {
    // Update the model with parsed value
    this.selectedFundingRMS.estimatedCost = this.parseCurrency(value);
  }
}


}
